import type { MembershipsTabKey } from './MembershipsTabs';

type Props = {
  activeTab: MembershipsTabKey;
  onExport?: () => void;
  exporting?: boolean;
  onNewTier?: () => void;
  onIssueMembership?: () => void;
};

const MembershipsHeader = ({ activeTab, onExport, exporting = false, onNewTier, onIssueMembership }: Props) => {
  const isMembersTab = activeTab === 'members';
  const isTiersTab = activeTab === 'tiers';
  // "+ New tier" belongs only where tiers are listed.
  // "+ Issue membership" appears on both Members and Tiers — Members opens
  // the phone-first sheet via URL plumbing; Tiers opens the modal inline.
  // Actions has neither — only its Export CTA.
  const showNewTier = isTiersTab;
  const showIssueMembership = isMembersTab || isTiersTab;
  return (
    <header className="memberships-page__header">
      <div className="memberships-page__title-block">
        <h1 className="memberships-page__title">Memberships</h1>
        <p className="memberships-page__subtitle">
          Manage your loyalty tiers, members, and engagement — all in one place.
        </p>
      </div>
      <div className="memberships-page__cta-group" role="group" aria-label="Memberships actions">
        <button
          type="button"
          className="memberships-page__cta"
          onClick={onExport}
          disabled={exporting}
        >
          {exporting ? 'Exporting…' : 'Export members'}
        </button>
        {showNewTier ? (
          <button
            type="button"
            className="memberships-page__cta memberships-page__cta--primary"
            onClick={onNewTier}
          >
            + New tier
          </button>
        ) : null}
          <button
            type="button"
            className="memberships-page__cta memberships-page__cta--primary"
            onClick={onIssueMembership}
          >
            + Issue membership
          </button>
      </div>
    </header>
  );
};

export default MembershipsHeader;
